import React, { useEffect, useState } from "react";
import AdminHead from "./AdminHead";
import '../Styles/Admin/ViewSapakim.css';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";
import { useNavigate, useParams } from "react-router-dom";

function ViewSapakim() {
  const [sapakimList, setSapakimList] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate()
  const {UID} = useParams()

  useEffect(() => {
    const fetchSapakim = async () => {
      try {
        const q = query(collection(db, "Users"), where("Role", "==", "Sapakim"));
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setSapakimList(data);
      } catch (error) {
        console.error("שגיאה בקבלת רשימת הספקים:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSapakim();
  }, []);

  return (
    <React.Fragment>
      <AdminHead />
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="VSF" dir="rtl">
            <h1>סה"כ סוכנים: {sapakimList.length}</h1>
            <button onClick={() => nav(`/AdminHome/${UID}/ViewSapakim/AddNewSapak`)}>סוכן חדש</button>
          </div>

          <div className="SIV" dir="rtl">
            {sapakimList.map((sapak) => (
              <div className="sapak-card" key={sapak.id}>
              <h3>{sapak.Name || "שם לא זמין"}</h3>
              <p><strong>שם עסק:</strong> {sapak.BName || "לא צויין"}</p>
              <p><strong>אימייל:</strong> {sapak.Email || "לא צויין"}</p>
              <p><strong>טלפון:</strong> {sapak.PhoneNumber || "לא צויין"}</p>
              <p><strong>ח.פ:</strong> {sapak.CompanyNumber || "לא צויין"}</p>
              <button onClick={() => nav(`/AdminHome/${UID}/ViewSapakim/${sapak.id}`)}>לצפייה בפרופיל</button>
            </div>
            
            ))}
          </div>
        </>
      )}
    </React.Fragment>
  );
}

export default ViewSapakim;
